import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import bootstrap_alert from "../bootstrap_alert";
import Sortable from "sortablejs";
import * as Sentry from "@sentry/browser";

export default class PortfolioEditor extends Controller {
  connect() {
    // handle the data/variables from the view to be used in the following functions
    this.portfolioEndPoint = this.data.get("portfolioEndPoint");
    this.portfolioAttachmentEndPoint = this.data.get(
      "portfolioAttachmentEndPoint",
    );
    this.auth = this.data.get("auth");
    this.locale = this.data.get("locale");
    this.mediaType = this.data.get("mediaType");
    this.attachmentId = this.data.get("attachmentId");

    // set the draggable element
    this.setDraggableElement();

    I18n.locale = this.locale;
  }

  setDraggableElement() {
    const element = document.querySelector(".draggable");
    this.sortable = Sortable.create(element, {
      // options
      sort: true,
      animation: 150,
      draggable: ".draggable-item",
      direction: "vertical",
    });
  }

  addPortfolio() {
    // show the apropriate modal to add text OR youtube/vinmo url as a portfolio attachment
    if (this.mediaType == "text") {
      $("#AddTextModal").modal("show");
    } else {
      $("#AddUrlModal").modal("show");
    }
  }

  closeAndClearModals() {
    document.addEventListener("turbo:submit-end", (event) => {
      if (
        (event.target.id === "addTextForm" ||
          event.target.id === "addUrlForm") &&
        event.detail.success
      ) {
        // close the modal
        const modal = document.querySelector(".modal.show");
        if (modal) {
          $(modal).modal("hide");
          $(".modal-backdrop").remove();
        }
        // clear the form
        event.target.reset();
      }
    });
  }

  showInstructions() {
    $("#InstructionsModal").modal("show");
  }

  async saveOrder() {
    const sortedItems = Array.from(
      this.element.querySelectorAll(".draggable-item"),
    ).map((el, index) => ({ id: el.id.split("_").pop(), index: index }));

    const payload = {
      portfolio: {
        portfolio_attachments_attributes: sortedItems.map((item) => ({
          id: item.id,
          index: item.index,
          content: item.content,
        })),
      },
      authenticity_token: this.auth,
    };

    try {
      await axios.put(this.portfolioEndPoint, payload).then((response) => {
        if (response.status == 200) {
          bootstrap_alert.notice(
            I18n.translate(
              "stimulus.portfolio_editor.attachment_reorder_message",
            ),
          );
        }
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  }
}
